import { render, staticRenderFns } from "./ConfirmationStep.vue?vue&type=template&id=8d8a88a8&scoped=true&lang=pug"
import script from "./ConfirmationStep.vue?vue&type=script&lang=js"
export * from "./ConfirmationStep.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationStep.vue?vue&type=style&index=0&id=8d8a88a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8a88a8",
  null
  
)

export default component.exports